import { initQueryClient } from '@ts-rest/react-query';
import React from 'react';
import { apiContract } from '@archie/api-shared';

export const INITIAL_QUERY_PROVIDER_CONTRACT = initQueryClient(apiContract, {
  baseUrl: '',
  baseHeaders: {}
});

export const QueryApiContext = React.createContext<typeof INITIAL_QUERY_PROVIDER_CONTRACT>(
  INITIAL_QUERY_PROVIDER_CONTRACT
);
